angular.module('TetherApp').controller('UserController', [
    '$window',
    '$mdDialog',
    '$mdToast',
    'userService',
    function (
        $window,
        $mdDialog,
        $mdToast,
        userService
    ) {
        let self = this;
        self.inputLists = userService.getListsData();
        self.outputLists = [];

        self.updateLists = function () {

            self.listIds = '';

            self.outputLists.forEach(function(list) {
                if(self.listIds == []) {
                    self.listIds = self.listIds + list.id;
                } else {
                    self.listIds = self.listIds + ',' + list.id;
                }
            }, self);

            angular.element('#lists').val(self.listIds);
        };

        let DialogController = function ($mdDialog) {
            let dCtrl = this;
            dCtrl.parent = self;
            dCtrl.message = undefined;

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                $mdDialog.cancel();
            };

            dCtrl.answer = function (answer) {
                $mdDialog.hide(answer);
            };

            let onSend = function (data) {
                //
            };

            let onError = function (data) {
                //
            };

        };

        this.delete = function(userId) {
            if($window.confirm(self.deleteConfirmationText)) {
                userService.deleteUser(userId)
                    .then(onSuccess, onError);
            }
        };

        this.disable = function(userId) {
            if($window.confirm(self.disableConfirmationText)) {
                userService.disableUser(userId)
                    .then(onSuccess, onError);
            }
        };

        this.enable= function(userId) {
            if($window.confirm(self.enableConfirmationText)) {
                userService.enableUser(userId)
                    .then(onSuccess, onError);
            }
        };

        let onSuccess = function (data) {
            $window.location.reload();
        };

        let onError = function(reason) {
            //
        };

        let onToggleLock = function (data) {
            window.location.reload(true);
        };

        let onToggleLockError = function (data) {
            $mdToast.show({
                hideDelay: 2000,
                position: 'bottom left',
                template: '<md-toast style="width: 350px;">' +
                    '<span class="md-toast-text"><i style="color:red;" class="fa fa-times" aria-hidden="true"></i> An error occurred, please contact support.</span>' +
                    '</md-toast>'
            });
        };

        this.toggleLock = function (id) {
            userService.toggleLock(id)
                .then(onToggleLock, onToggleLockError);
        };

        let onTogglePasswordReset = function (data) {
            $mdToast.show({
                hideDelay: 2000,
                position: 'bottom left',
                template: '<md-toast style="width: 470px;">' +
                    '<span class="md-toast-text"><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> ' + data.success + '</span>' +
                    '</md-toast>'
            });
        };

        let onTogglePasswordResetError = function (data) {
            $mdToast.show({
                hideDelay: 2000,
                position: 'bottom left',
                template: '<md-toast style="width: 470px;">' +
                    '<span class="md-toast-text"><i style="color:red;" class="fa fa-times" aria-hidden="true"></i> An error occurred, please contact support.</span>' +
                    '</md-toast>'
            });
        };

        this.togglePasswordReset = function (id) {
            userService.togglePasswordReset(id)
                .then(onTogglePasswordReset, onTogglePasswordResetError);
        };
    }
]);
